var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.20996L17 9.39996V13.5",
    stroke: "#7647EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 15.9999V7.9999C21.4996 7.64918 21.4071 7.30471 21.2315 7.00106C21.056 6.69742 20.8037 6.44526 20.5 6.2699L13.5 2.2699C13.196 2.09437 12.8511 2.00195 12.5 2.00195C12.1489 2.00195 11.804 2.09437 11.5 2.2699L4.5 6.2699C4.19626 6.44526 3.94398 6.69742 3.76846 7.00106C3.59294 7.30471 3.50036 7.64918 3.5 7.9999V15.9999C3.50036 16.3506 3.59294 16.6951 3.76846 16.9987C3.94398 17.3024 4.19626 17.5545 4.5 17.7299L11.5 21.7299C11.804 21.9054 12.1489 21.9979 12.5 21.9979C12.8511 21.9979 13.196 21.9054 13.5 21.7299L20.5 17.7299C20.8037 17.5545 21.056 17.3024 21.2315 16.9987C21.4071 16.6951 21.4996 16.3506 21.5 15.9999Z",
    stroke: "#7647EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77002 6.95996L12.5 12.01L21.23 6.95996",
    stroke: "#7647EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22.08V12",
    stroke: "#7647EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductBox);
export default __webpack_public_path__ + "static/media/product-box.97faf71ccb88fc40bcd574c81cbc4683.svg";
export { ForwardRef as ReactComponent };